import { HTTP_CP_SignUp_Request_ENUM_SignUpCreationMethod } from '@api-new/authservice';
import { ENTRY_FLOW_STEPS } from '@app/sign-up/constants/entry-flow';
import { FLOWS } from '@app/sign-up/constants/flows';
import { FlowStepTypeModel } from '@shared/store/sign-up/flow/flow.model';

export const getFlowSteps = (creationMethod: HTTP_CP_SignUp_Request_ENUM_SignUpCreationMethod | null): FlowStepTypeModel | undefined => {
  return creationMethod != null ? FLOWS[creationMethod]?.steps : ENTRY_FLOW_STEPS;
};
